import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../abstract/base.service';
import { DroneModel } from '../data-models/drone-model.model';
import { CreateDroneModelRequest } from '../request-models/create-drone-model-request.model';
import { DroneModelRequest } from '../request-models/drone-model-request.model';
import { toCreateDroneModelRequest, toDroneModelRequest } from '../utils/drone-catalog-request-utils';

/** The drone catalog's models: `/admin/drone-models` (hub `admin-drone-models-controller.ts`). */
@Injectable({ providedIn: 'root' })
export class DroneModelService extends BaseService<DroneModel> {
  constructor() {
    super('admin/drone-models', DroneModel);
  }

  /** GET /admin/drone-models (unpaged), optionally only one manufacturer's. */
  getModels(manufacturerId?: string): Observable<DroneModel[]> {
    return this.getMany({ query: { manufacturerId: manufacturerId || undefined } });
  }

  /** GET /admin/drone-models/:id. Emits `null` when the hub returns no data. */
  getModel(modelId: string): Observable<DroneModel | null> {
    return this.get(modelId);
  }

  /** POST /admin/drone-models with the manufacturer and only the writable fields that are set. */
  createModel(fields: CreateDroneModelRequest): Observable<DroneModel | null> {
    return this.create(toCreateDroneModelRequest(fields));
  }

  /** PUT /admin/drone-models/:id with only the writable fields that are set. */
  updateModel(modelId: string, fields: DroneModelRequest): Observable<DroneModel | null> {
    return this.update(modelId, toDroneModelRequest(fields));
  }

  /** DELETE /admin/drone-models/:id (the hub archives it). */
  archiveModel(modelId: string): Observable<void> {
    return this.delete(modelId);
  }
}
